import { authenticationTypes } from 'root/src/shared/constants/auth';
import { AuthGroup } from 'root/src/server/util/awsClients/authApiClient.types';
import { otherEndpointType } from 'root/src/shared/descriptions/endpoints/lenses';
import { notificationEndpointIds } from 'root/src/shared/notification/notification.fixture';
import { NotificationTargetType, NotificationType, } from 'root/src/shared/notification/notification.types';
const definition = {
    endpointType: otherEndpointType,
    payloadSchema: {
        type: 'object',
        properties: {
            content: {
                type: 'string',
                description: 'Content of the notification',
            },
            type: {
                type: 'string',
                enum: Object.values(NotificationType),
                description: 'Type of the notification',
            },
            target: {
                type: 'object',
                properties: {
                    type: {
                        type: 'string',
                        enum: Object.values(NotificationTargetType),
                        description: 'Target of the notification',
                    },
                    value: {
                        type: 'string',
                        description: 'ID of the target',
                    },
                },
                required: ['type'],
            },
        },
        required: ['content', 'type', 'target'],
    },
};
export const createNotificationEndpoint = {
    [notificationEndpointIds.CREATE_NOTIFICATION]: definition,
    [notificationEndpointIds.CREATE_NOTIFICATION_TRIGGER]: Object.assign(Object.assign({}, definition), { authentication: authenticationTypes.authenticated, authenticationRole: AuthGroup.Admin }),
};
